module.exports = __webpack_public_path__ + "img/h2.76b9795b.jpg";